import { createType } from '../dependencies';

export default {
    ...createType('REQUEST_MENUS'),
    SET_MENUS: 'SET_MENUS',
};
